import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import SvgIcon from "@client.components/SvgIcon";
import "./Icon.scss";

const Icon = ({ name, isSvg = false, className, ...rest }) => {
  return isSvg ? (
    <SvgIcon name={name} className={className} {...rest} />
  ) : (
    <span
      className={classNames("icon", `icon-${name}`, className)}
      {...rest}
    ></span>
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  isSvg: PropTypes.bool,
};

export default Icon;
